
import { Tabs } from "@shared/ui/tabs";
import { Button } from "@shared/ui/button";
import { 
  Plus,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Summary } from "../payments/summary/summary";
import { PaymentList } from "../payments/list";
import { CreditNoteList } from "../creditNote/creditnotelist";

const PaymentsLandingPage = () => {
  const navigate = useNavigate();


  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
      <div>
        <h1 className="page-title">Payments Management </h1>
        <p className="page-subtitle">Manage all payment transactions, create credit notes, and track payment history across all channels</p>
      </div>

        <div className="flex gap-2">
        <Button onClick={() => navigate("/cx/payments/create")}>
            <Plus className="mr-2 h-4 w-4" />
           Record Payment
          </Button>
          </div>
      </div>

      <Summary />

  <Tabs 
        defaultValue="current"
        className="w-full"
        tabsListClassName="grid w-full grid-cols-2 mb-6"
        urlMapping={{
          allPayments: "allPayments",
          creditNotes: "creditNotes",
        }}
        tabComponents={{
          allPayments: {
            label: "All Payments",
            component: <PaymentList />
          },
          creditNotes: {
            label: "Credit Notes",
            component: <CreditNoteList />
          }
        }}
      />
      </div>
  );
};

export default PaymentsLandingPage;
